import { render, staticRenderFns } from "./VehicleInsurance.vue?vue&type=template&id=9564185a&scoped=true&"
import script from "./VehicleInsurance.vue?vue&type=script&lang=js&"
export * from "./VehicleInsurance.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInsurance.vue?vue&type=style&index=0&id=9564185a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9564185a",
  null
  
)

export default component.exports